// Provider visual metadata (colors match design_guidelines.json)
export const PROVIDER_STYLES = {
  Uber:     { bg: "bg-black",           text: "text-white", initial: "U" },
  Ola:      { bg: "bg-[#CBE12B]",       text: "text-black", initial: "O" },
  Rapido:   { bg: "bg-[#F9C900]",       text: "text-black", initial: "R" },
  BluSmart: { bg: "bg-[#007AFF]",       text: "text-white", initial: "B" },
  inDrive:  { bg: "bg-[#A3E635]",       text: "text-black", initial: "iD" },
  Meru:     { bg: "bg-[#EF4444]",       text: "text-white", initial: "M" },
};

export const RIDE_TYPES = ["All", "Bike", "Auto", "Mini", "Sedan", "SUV"];

export const RIDE_TYPE_META = {
  Bike:  { icon: "Bike",       desc: "Fastest • 1 rider" },
  Auto:  { icon: "TramFront",  desc: "3 riders" },
  Mini:  { icon: "Car",        desc: "Hatchback • 4 riders" },
  Sedan: { icon: "CarFront",   desc: "Sedan • 4 riders" },
  SUV:   { icon: "Truck",      desc: "SUV • 6 riders" },
};
